import { gql } from '@apollo/client'

export const INVENTORY_ORDER_ITEM_FIELDS = gql`
  fragment InventoryOrderItemFields on InventoryOrderItem {
    id
    notes
    orderedQuantity
    packageType {
      id
    }
    packageUnits {
      id
    }
    perPackageAmount
    manufacturer {
      id
      name
    }
    externalItemName
    ndc
    upc
    sku
    status {
      id
      name
    }
    inventoryItem {
      id
      name
      variation {
        id
        composedName
        cumulusId
      }
      category {
        id
      }
      controlled
      storeCold
    }
    receipts {
      id
      creationDate
      receivedQuantity
      lotNumber
      serialNumber
      businessReferenceNumber
      expirationDate
      damageReason {
        id
      }
      damageNotes
    }
  }
`

export const INVENTORY_ORDER_FIELDS = gql`
  ${INVENTORY_ORDER_ITEM_FIELDS}
  fragment InventoryOrderFields on InventoryOrder {
    id
    externalCreatorEmail
    externalCreatorFirstName
    externalCreatorLastName
    orderNumber
    orderedDate
    distributor {
      id
      name
    }
    items {
      ...InventoryOrderItemFields
    }
    status {
      id
      name
    }
  }
`
